import type { ScenarioComponentNames } from "@/models";

const scenarioComponentNames: ScenarioComponentNames = {
  wind: "wind",
  sun: "sun",
  noise: "noise",
  stormwater: "stormwater",
  pedestrian: "pedestrian",
  accessibility: "accessibility",
  multiLayer: "multiLayer",
};

export default scenarioComponentNames;
